import { Link, useSearchParams } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { CATEGORIES } from "@/lib/api";

function Box({ title, children }) {
  return (
    <div className="border-b border-slate-200 p-4 last:border-0">
      <div className="font-display font-semibold text-slate-900 mb-3">{title}</div>
      {children}
    </div>
  );
}

function Checks({ options, selected, onToggle, prefix }) {
  return (
    <div className="space-y-2.5 max-h-56 overflow-y-auto">
      {options.map(([name, n]) => (
        <label key={name} className="flex items-center gap-2.5 text-sm cursor-pointer">
          <Checkbox data-testid={`${prefix}-${name}`} checked={selected.includes(name)} onCheckedChange={() => onToggle(name)} />
          <span>{name} <span className="text-slate-400">({n})</span></span>
        </label>
      ))}
    </div>
  );
}

const count = (arr, key) => Object.entries(arr.reduce((m, p) => (p[key] ? { ...m, [p[key]]: (m[p[key]] || 0) + 1 } : m), {}));

export default function Filters({ products, all, value, onChange }) {
  const [params] = useSearchParams();
  const toggle = (k, v) => onChange({ ...value, [k]: value[k].includes(v) ? value[k].filter((x) => x !== v) : [...value[k], v] });
  return (
    <div className="bg-white rounded-lg border border-slate-200" data-testid="filters-panel">
      <Box title="Kategori">
        <div className="space-y-1.5 text-sm">
          {CATEGORIES.map((c) => (
            <Link key={c.key} to={`/?cat=${c.key}`} data-testid={`filter-cat-${c.key}`}
              className={`block ${params.get("cat") === c.key ? "text-[#172554] font-bold" : "text-slate-700 hover:text-[#172554]"}`}>
              {c.label} ({all.filter((p) => p.category === c.key).length})
            </Link>
          ))}
        </div>
      </Box>
      <Box title="Marka"><Checks prefix="filter-brand" options={count(products, "brand")} selected={value.brands} onToggle={(v) => toggle("brands", v)} /></Box>
      <Box title="Çeşit / Aroma"><Checks prefix="filter-flavor" options={count(products, "flavor")} selected={value.flavors} onToggle={(v) => toggle("flavors", v)} /></Box>
      <Box title="Fiyat Aralığı (TL)">
        <div className="flex gap-2">
          <input data-testid="filter-price-min" type="number" placeholder="En az" value={value.min} onChange={(e) => onChange({ ...value, min: e.target.value })} className="w-full h-10 border rounded-md px-3 text-sm" />
          <input data-testid="filter-price-max" type="number" placeholder="En çok" value={value.max} onChange={(e) => onChange({ ...value, max: e.target.value })} className="w-full h-10 border rounded-md px-3 text-sm" />
        </div>
        <button data-testid="filter-clear" onClick={() => onChange({ brands: [], flavors: [], min: "", max: "" })} className="mt-3 text-xs font-semibold text-[#172554] hover:underline">Filtreleri temizle</button>
      </Box>
    </div>
  );
}
